import AnimatedPath from "./private/AnimatedPath.js";
import BaseAreaSeries from "./private/BaseAreaSeries.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedAreaSeries(props) {
  return /*#__PURE__*/_jsx(BaseAreaSeries, {
    ...props,
    PathComponent: AnimatedPath
  });
}